import BottomNav from "@/components/BottomNav";

export default function Layout({ children, hideNav = false }) {
  return (
    <div className="relative mx-auto min-h-screen w-full max-w-md bg-[#FDFBF7] shadow-2xl">
      <div className={hideNav ? "" : "pb-24"}>{children}</div>
      {!hideNav && <BottomNav />}
    </div>
  );
}
